import { Observable } from 'rxjs/Observable';
import { WarmUpService, ApplicationTypeConstants } from './../../../../../services/warmup/warmup.service';
import { ApplicationValue } from './../../../../../services/warmup/application-type.model';
import { ResolveSanctionMatchComponent } from 'app/entities/monitoring/actual/sanction/resolvesanction/resolve-sanction.component';
import { Component, OnInit, OnChanges, ViewContainerRef, Input } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { ConstantsService } from 'app/services/constants-service';

import { UpdateSanctionMatchComponent } from 'app/entities/monitoring/actual/sanction/sanctionmatch/updatesanctionmatch/update-sanction-match.component';
import { SanctionDetailsComponent } from 'app/entities/monitoring/actual/sanction/sanctiondetails/sanction-details.component';
import { Sanction } from 'app/shared/models/sanction.model';
import { SanctionService } from 'app/entities/monitoring/actual/sanction/sanction.service';
import { PersonHeaderService } from 'app/person/header/person-header.service';
import { ClientHeaderService } from 'app/clients/client/header/client-header.service';
import { EntityMonitoringService } from 'app/entities/monitoring/entity-monitoring.service';

import { EntityType, EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { SanctionMatchResponse, SanctionEntity } from 'app/entities/monitoring/actual/sanction-matches.model';
import { OrganisationDetails } from 'app/shared/models/org-details.model';
import { SanctionMatchRecord } from 'app/entities/monitoring/actual/sanction-matches.model';

@Component({
  selector: 'sanction-match',
  providers: [SanctionService],
  templateUrl: './sanction-match.component.html',
  styleUrls: ['./sanction-match.component.css']
})

/**
 * Component to display the monitoring sanction for the entity.
 */
export class SanctionMatchComponent implements OnInit, OnChanges {
  @Input() entityIdDetails: EntityIdDetails;

  public id: number;
  public personId: number;
  public orgId: number;
  public isEntityPerson = false;

  dialogRef: MdDialogRef<any>;
  sanctionMatchData: any;
  sanctionPersonData: any;
  sanctionOrgClientData = new OrganisationDetails();
  // sanctionClientData: any;
  sanctionMatchDataLength: number;
  sanctionMatchLoaded = false;
  matchResolutions: ApplicationValue[];
  falseMatchReasons: ApplicationValue[];

  constructor(
    public dialog: MdDialog,
    public viewContainerRef: ViewContainerRef,
    private sanctionMatchService: SanctionService,
    private snackBarService: SnackBarService,
    private personHeaderService: PersonHeaderService,
    private clientHeaderService: ClientHeaderService,
    private entityMonitoringService: EntityMonitoringService,
    private trackingService: TrackingService,
    private warmUpService: WarmUpService) { }

  ngOnInit() {
    this.ngOnChanges();
    this.setUpMatchResolutions(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.SANCTION_MATCH_RESOLUTION));
    this.setUpFalseMatchReasons(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.FALSE_MATCH_REASONS));
  }

  setUpMatchResolutions(dropDownValues: any) {
    if (dropDownValues instanceof Observable) {
      dropDownValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.matchResolutions = response.values;
        }
      );
    } else {
      this.matchResolutions = dropDownValues;
    }
  }

  setUpFalseMatchReasons(dropDownValues: any) {
    if (dropDownValues instanceof Observable) {
      dropDownValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.falseMatchReasons = response.values;
        }
      );
    } else {
      this.falseMatchReasons = dropDownValues;
    }
  }

  ngOnChanges() {
    if (this.entityIdDetails && this.entityIdDetails.entityId) {
      this.id = this.entityIdDetails.entityId;
      if (this.entityIdDetails.isPerson) {
        this.isEntityPerson = this.entityIdDetails.isPerson;
        this.personId = this.entityIdDetails.personId;
      } else {
        this.orgId = this.entityIdDetails.orgId;
      }
      this.getSanctionMatchDesc();
    }
  }

  // Get Monitoring Elaboration Text Description..
  getSanctionMatchDesc() {
    this.sanctionMatchLoaded = false;
    this.sanctionMatchData = '';

    if (this.entityIdDetails.isPerson) {
      this.personHeaderService.getPerson(this.personId)
        .subscribe(response => {
          response.arrResult.personBirthdayForPrint = this.entityMonitoringService.getDateForPrint(response.arrResult.birthday);
          this.sanctionPersonData = response.arrResult;
        });
    } else {
      this.clientHeaderService.getOrganisationDetails(this.orgId)
        .subscribe(response => {
          if (response.organisationVO && response.organisationVO.incorporatedDate) {
            response.organisationVO.incorporatedDateForPrint =
              this.entityMonitoringService.getDateForPrint(response.organisationVO.incorporatedDate);
          }
          this.sanctionOrgClientData = response;
        });
    }

    this.sanctionMatchService.getSanctionInfoMatchDesc(this.id, this.entityIdDetails.entityType)
      .subscribe(response => {
        for (const index in response.suggestionList) {
          response.suggestionList[index].sanctionEntity.isJsonDataValid = false;
          if (response.suggestionList[index].sanctionEntity.jsonData) {
            try {
              response.suggestionList[index].sanctionEntity.detailsData = JSON.parse(response.suggestionList[index].sanctionEntity.jsonData);
              // Sometimes the birthdate in outer array is blank, but it is there is inner jsonData,
              // So we will provide it in outer array if available.
              if (response.suggestionList[index].sanctionEntity.birthDate) {
                response.suggestionList[index].sanctionEntity.birthDate = this.entityMonitoringService.getDateForPrint(response.suggestionList[index].sanctionEntity.birthDate);
              }
              else if (response.suggestionList[index].sanctionEntity.detailsData.birthDate) {
                response.suggestionList[index].sanctionEntity.birthDate = this.entityMonitoringService.getDateForPrint(response.suggestionList[index].sanctionEntity.detailsData.birthDate);
              }
              response.suggestionList[index].recordCounter = index;
              response.suggestionList[index].sanctionEntity.isJsonDataValid = true;
            } catch (e) {
              response.suggestionList[index].sanctionEntity.isJsonDataValid = false;
            }
          }
        }
        this.sanctionMatchData = response;
        this.sanctionMatchLoaded = true;
        this.sanctionMatchDataLength = response.suggestionList.length;
      });
  }

  // Open dialog having text editor to update Monitoring Elaboration text.
  openSanctionMatchUpdateDialog() {
    const config = new MdDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(UpdateSanctionMatchComponent, config);
    this.dialogRef.componentInstance.argId = this.id;
    this.dialogRef.componentInstance.argEntityType = this.entityIdDetails.entityType;
    this.dialogRef.componentInstance.argSanctionMatchDetailsData = this.sanctionMatchData;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      this.getSanctionMatchDesc();
    });
  }

  resolveSanctionMatch(sanctionMatchRecord: SanctionMatchRecord, relationEntityId: number) {
    const config = new MdDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(ResolveSanctionMatchComponent, config);
    this.dialogRef.componentInstance.sanctionMatchRecord = sanctionMatchRecord;
    this.dialogRef.componentInstance.relationEntityId = relationEntityId;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      if (result) {
        this.getSanctionMatchDesc();
      }
    });
  }

  openSanctionMatchMoreDetailsDialog(recordCounter) {
    const config = new MdDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(SanctionDetailsComponent, config);
    this.dialogRef.componentInstance.argId = this.id;
    this.dialogRef.componentInstance.argEntityType = this.entityIdDetails.entityType;
    this.dialogRef.componentInstance.argSanctionDetailsData =
      this.sanctionMatchData.suggestionList[recordCounter].sanctionEntity.detailsData;
    this.dialogRef.componentInstance.argSanctionOrgClientData = this.sanctionOrgClientData;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      this.getSanctionMatchDesc();
    });
  }

  getMatchStatus(matchId) {
    if (this.matchResolutions) {
      const match = this.matchResolutions.find(matchResolution => matchResolution.id === matchId);
      if (match) {
        return match.name;
      }
    }
    return 'Probable';
  }

  getFalseMatchReason(matchId) {
    if (this.falseMatchReasons) {
      const match = this.falseMatchReasons.find(falseMatchReason => falseMatchReason.id === matchId);
      if (match) {
        return match.name;
      }
    }
    return 'N/A';
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/sanction/sanctionmatch/sanction-match.component.ts